<template>
  <el-card class="product-questions mb-4" shadow="hover">
    <div slot="header" class="d-flex justify-content-between align-items-center">
      <span class="font-weight-bold title">4. Danh sách câu hỏi khi mua vé (Questions)</span>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openCreateDialog">
        Thêm câu hỏi
      </el-button>
    </div>

    <el-table v-loading="loading" :data="questionList" border style="width: 100%;">
      <el-table-column prop="id" label="ID" width="100" />
      <el-table-column prop="key" label="Mã khóa (Key)" width="150">
        <template slot-scope="scope">
          <el-tag type="info">{{ scope.row.key }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Nhãn (Label)">
        <template slot-scope="scope">
          <div><strong>EN:</strong> {{ getLabelEn(scope.row.label) }}</div>
          <div v-if="getLabelVi(scope.row.label)"><strong>VI:</strong> {{ getLabelVi(scope.row.label) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="answer_type" label="Loại câu trả lời" width="140">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.answer_type || 'text' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="required" label="Bắt buộc" width="110">
        <template slot-scope="scope">
          <el-tag :type="scope.row.required ? 'danger' : 'info'" size="mini">
            {{ scope.row.required ? 'Bắt buộc' : 'Không' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Thao tác" width="100" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #F56C6C;"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          >
            Xóa
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Dialog Thêm mới Câu hỏi -->
    <el-dialog
      title="Thêm Câu Hỏi Khi Mua Vé"
      :visible.sync="dialogVisible"
      width="500px"
      append-to-body
    >
      <el-form ref="form" v-loading="submitting" :model="form" :rules="rules" label-width="160px">
        <el-form-item label="Mã khóa (Key)" prop="key">
          <el-input v-model="form.key" placeholder="Ví dụ: full_name, phone_number" />
        </el-form-item>

        <el-form-item label="Tiêu đề Tiếng Anh" prop="label_en">
          <el-input v-model="form.label_en" placeholder="Ví dụ: Full name" />
        </el-form-item>

        <el-form-item label="Tiêu đề Tiếng Việt">
          <el-input v-model="form.label_vi" placeholder="Ví dụ: Họ và tên" />
        </el-form-item>

        <el-form-item label="Loại câu trả lời" prop="answer_type">
          <el-select v-model="form.answer_type" style="width: 100%;">
            <el-option label="Text (Văn bản)" value="text" />
            <el-option label="Number (Số)" value="number" />
            <el-option label="Boolean (Có/Không)" value="boolean" />
            <el-option label="Select (Lựa chọn)" value="select" />
          </el-select>
        </el-form-item>

        <el-form-item label="Yêu cầu bắt buộc">
          <el-switch v-model="form.required" active-text="Bắt buộc" inactive-text="Không" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Hủy</el-button>
        <el-button type="primary" :loading="submitting" @click="handleCreate">Thêm mới</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { getQuestions, createQuestion, deleteQuestion } from '@/services/product'

export default {
  name: 'ProductQuestions',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      submitting: false,
      dialogVisible: false,
      questionList: [],
      form: {
        key: 'full_name',
        label_en: 'Full name',
        label_vi: 'Họ và tên',
        answer_type: 'text',
        required: true
      },
      rules: {
        key: [{ required: true, message: 'Vui lòng nhập Key', trigger: 'blur' }],
        label_en: [{ required: true, message: 'Vui lòng nhập Label Tiếng Anh', trigger: 'blur' }],
        answer_type: [{ required: true, message: 'Vui lòng chọn loại câu trả lời', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.fetchQuestions()
  },
  methods: {
    getProductId() {
      return this.product.id || this.product._id
    },
    getLabelEn(labelObj) {
      if (!labelObj) return ''
      if (typeof labelObj === 'string') return labelObj
      return labelObj.en || labelObj.vi || ''
    },
    getLabelVi(labelObj) {
      if (!labelObj || typeof labelObj === 'string') return ''
      return labelObj.vi || ''
    },
    fetchQuestions() {
      const productId = this.getProductId()
      if (!productId) return
      this.loading = true
      getQuestions(productId).then((res) => {
        const data = res.data || res
        this.questionList = Array.isArray(data) ? data : (data.items || data.list || [])
      }).catch(() => {
        this.questionList = []
      }).finally(() => {
        this.loading = false
      })
    },
    openCreateDialog() {
      this.form = {
        key: 'full_name',
        label_en: 'Full name',
        label_vi: 'Họ và tên',
        answer_type: 'text',
        required: true
      }
      this.dialogVisible = true
    },
    handleCreate() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        const productId = this.getProductId()
        this.submitting = true

        const payload = {
          key: this.form.key,
          label: {
            en: this.form.label_en,
            ...(this.form.label_vi ? { vi: this.form.label_vi } : {})
          },
          answer_type: this.form.answer_type,
          required: this.form.required
        }

        createQuestion(productId, payload).then((res) => {
          this.$message.success('Thêm câu hỏi thành công!')
          this.dialogVisible = false
          this.fetchQuestions()
        }).catch((err) => {
          const errMsg = (err && err.message) ? err.message : 'Lỗi khi thêm câu hỏi'
          this.$message.error(errMsg)
        }).finally(() => {
          this.submitting = false
        })
      })
    },
    handleDelete(row) {
      this.$confirm('Bạn có chắc chắn muốn xóa câu hỏi này?', 'Xác nhận xóa', {
        type: 'warning'
      }).then(() => {
        const productId = this.getProductId()
        const questionId = row.id || row._id
        deleteQuestion(productId, questionId).then(() => {
          this.$message.success('Xóa câu hỏi thành công!')
          this.fetchQuestions()
        }).catch((err) => {
          const errMsg = (err && err.message) ? err.message : 'Không thể xóa câu hỏi'
          this.$message.error(errMsg)
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.product-questions .title {
  font-size: 16px;
}
.d-flex {
  display: flex;
}
.justify-content-between {
  justify-content: space-between;
}
.align-items-center {
  align-items: center;
}
</style>
